import React from 'react';

interface StatisticsTableProps<T> {
  columns: { key: keyof T | string; label: string; render?: (row: T) => React.ReactNode }[];
  data: T[];
  className?: string;
}

export function StatisticsTable<T extends { [key: string]: any }>({ columns, data, className = '' }: StatisticsTableProps<T>) {
  return (
    <div className={`overflow-x-auto rounded-2xl shadow border ${className}`}>
      <table className="min-w-full bg-white">
        <thead>
          <tr className="bg-gray-50 border-b">
            {columns.map(col => (
              <th key={col.key as string} className="px-4 py-3 text-left text-xs font-bold text-gray-600 uppercase tracking-wide">
                {col.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.length === 0 ? (
            <tr>
              <td colSpan={columns.length} className="text-center py-8 text-gray-400">Veri bulunamadı</td>
            </tr>
          ) : (
            data.map((row, idx) => (
              <tr key={row.id || idx} className={idx % 2 === 0 ? 'bg-white' : 'bg-gray-50/50'}>
                {columns.map(col => (
                  <td key={col.key as string} className="px-4 py-3 text-sm text-gray-900">
                    {col.render ? col.render(row) : row[col.key as keyof T]}
                  </td>
                ))}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}

export default StatisticsTable; 